import { useEffect, useState } from "react";
import API from "../../services/api";

function useOrgOptions(endpoint) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    API.get(endpoint)
      .then((res) => {
        if (!cancelled) setOptions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [endpoint]);

  return { options, loading };
}

const selectCls =
  "w-full border border-slate-200 rounded-xl px-3.5 py-2.5 text-sm bg-white text-slate-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-violet-500/25 focus:border-violet-400";

function StructureSelect({
  endpoint,
  value,
  onChange,
  label,
  required = false,
  disabled = false,
  emptyLabel = "Select",
  className = "",
  hideSelectedHint = false,
}) {
  const { options, loading } = useOrgOptions(endpoint);
  const selected = options.find((o) => String(o.id) === String(value));

  return (
    <div className={className}>
      {label ? (
        <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1.5">
          {label}
          {required ? <span className="text-red-400 ml-0.5">*</span> : null}
        </label>
      ) : null}
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : options.length === 0 ? (
        <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-2">
          No options found. Add them under Setup → Organisation Structure.
        </p>
      ) : (
        <select
          className={selectCls}
          value={value || ""}
          onChange={(e) => {
            const opt = options.find((o) => String(o.id) === e.target.value);
            onChange(e.target.value || null, opt);
          }}
          required={required}
          disabled={disabled}
        >
          <option value="">{emptyLabel}</option>
          {options.map((o) => (
            <option key={o.id} value={o.id}>
              {o.name}
            </option>
          ))}
        </select>
      )}
      {selected && !loading && !hideSelectedHint ? (
        <p className="mt-1 text-xs text-slate-500">{selected.name}</p>
      ) : null}
    </div>
  );
}

export function DepartmentSelect(props) {
  return <StructureSelect endpoint="/setup/departments" emptyLabel="Select department" {...props} />;
}

export function DesignationSelect(props) {
  return <StructureSelect endpoint="/setup/designations" emptyLabel="Select designation" {...props} />;
}

export function LocationSelect(props) {
  return <StructureSelect endpoint="/setup/locations" emptyLabel="Select location" {...props} />;
}
